import type { ContainerStatus, SslStatus } from '@/types';

const containerColors: Record<ContainerStatus, string> = {
  RUNNING: 'bg-status-running/15 text-status-running',
  BUILDING: 'bg-status-building/15 text-status-building',
  STOPPED: 'bg-status-stopped/15 text-status-stopped',
  ERROR: 'bg-status-error/15 text-status-error',
  PENDING: 'bg-status-pending/15 text-status-pending',
};

const sslColors: Record<SslStatus, string> = {
  ACTIVE: 'bg-ssl-active/15 text-ssl-active',
  PROVISIONING: 'bg-ssl-provisioning/15 text-ssl-provisioning',
  PENDING: 'bg-ssl-pending/15 text-ssl-pending',
  ERROR: 'bg-ssl-error/15 text-ssl-error',
};

export function ContainerStatusBadge({ status }: { status: ContainerStatus }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${containerColors[status]}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </span>
  );
}

export function SslStatusBadge({ status }: { status: SslStatus }) {
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${sslColors[status]}`}>
      {status}
    </span>
  );
}

export function DnsVerifiedBadge({ verified }: { verified: boolean }) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ${
        verified
          ? 'bg-green-500/15 text-green-400'
          : 'bg-yellow-500/15 text-yellow-400'
      }`}
    >
      {verified ? 'Verified' : 'Unverified'}
    </span>
  );
}
